import api from './httpClient';

export const AuthApi = {
  login: async ({ username, password }) => {
    const response = await api.post('/admin/login', { username, password });
    return response.data.data;
  }
};
